/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDUturnRightDownIcon32Regular = forwardRef('ArrowDUturnRightDownIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M24 14.5C24 8.701 19.299 4 13.5 4S3 8.701 3 14.5V22a1 1 0 1 0 2 0v-7.5a8.5 8.5 0 0 1 17 0v9.971l-5.77-6.155a1 1 0 1 0-1.46 1.368l6.041 6.444a3 3 0 0 0 4.378 0l6.04-6.444a1 1 0 1 0-1.459-1.368L24 24.471V14.5Z" })));
});
